export default __webpack_public_path__ + "static/media/GoldPlatedBengalAcrylicPolaBangles.d03ed38c.jpg";